import Splide from "@splidejs/splide";
import splideGeneralOptions from "@/Utils/splideGeneralOptions.js";

window.Splide = Splide;
window.splideGeneralOptions = splideGeneralOptions;

